// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { filecoin as _filecoin } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the filecoin chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 314
 * Chain Name: Filecoin Mainnet
 * Default Block Explorer: https://filfox.info/en
 * Default RPC URL: https://api.node.glif.io/rpc/v1
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { filecoin } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: filecoin,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const filecoin = createCommon({
	..._filecoin,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
